// import { useState, useEffect, useRef } from 'react';

// const TimePicker = ({ value, onChange, className = "" }) => {

//     const [isOpen, setIsOpen] = useState(false);
//     const [selectedHour, setSelectedHour] = useState(9);
//     const [selectedMinute, setSelectedMinute] = useState(0);
//     const [isAm, setIsAm] = useState(true);
//     const timePickerRef = useRef(null);
//     // Initialize from prop value
//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (timePickerRef.current && !timePickerRef.current.contains(event.target)) {
//                 setIsOpen(false);
//             }
//         };

//         if (isOpen) {
//             document.addEventListener('mousedown', handleClickOutside);
//             document.addEventListener('touchstart', handleClickOutside);
//         }

//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//             document.removeEventListener('touchstart', handleClickOutside);
//         };
//     }, [isOpen]);




//     const hours = Array.from({ length: 12 }, (_, i) => i + 1); // 1-12 for AM/PM
//     const minutes = Array.from({ length: 12 }, (_, i) => i * 5); // 00, 05, 10, 15, ... 55

//     const formatTime = (hour, minute, isAm) => {
//         // Convert to 24-hour format for API
//         let twentyFourHour = hour;
//         if (isAm && hour === 12) twentyFourHour = 0;
//         if (!isAm && hour !== 12) twentyFourHour = hour + 12;

//         return `${twentyFourHour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
//     };

//     const handleHourSelect = (hour) => {
//         setSelectedHour(hour);
//         const newTime = formatTime(hour, selectedMinute, isAm);
//         onChange(newTime);
//     };

//     const handleMinuteSelect = (minute) => {
//         setSelectedMinute(minute);
//         const newTime = formatTime(selectedHour, minute, isAm);
//         onChange(newTime);
//     };

//     const handleAmPmSelect = (am) => {
//         setIsAm(am);
//         const newTime = formatTime(selectedHour, selectedMinute, am);
//         onChange(newTime);
//     };

//     const handleToggle = () => {
//         setIsOpen(!isOpen);
//     };

//     // Convert 24h to 12h for display
//     const getDisplayHour = (hour24) => {
//         if (hour24 === 0) return 12;
//         if (hour24 > 12) return hour24 - 12;
//         return hour24;
//     };

//     const getDisplayAmPm = (hour24) => hour24 < 12 ? 'AM' : 'PM';

//     const displayHour = value ? getDisplayHour(parseInt(value.split(':')[0])) : selectedHour;
//     const displayMinute = value ? parseInt(value.split(':')[1]) : selectedMinute;
//     const displayAmPm = value ? getDisplayAmPm(parseInt(value.split(':')[0])) : (isAm ? 'AM' : 'PM');

//     const displayValue = value
//         ? `${displayHour}:${displayMinute.toString().padStart(2, '0')} ${displayAmPm}`
//         : `${selectedHour}:${selectedMinute.toString().padStart(2, '0')} ${isAm ? 'AM' : 'PM'}`;

//     return (
//         <div ref={timePickerRef} className={`relative ${className}`}>
//             {/* Custom-styled display */}
//             <button
//                 type="button"
//                 onClick={handleToggle}
//                 className="
//           w-32 px-4 py-3 
//           rounded-2xl 
//           border-2 
//           text-black 
//           font-semibold
//           hover:border-orange-600
//           transition-colors
//           flex items-center justify-between
//         "
//             >
//                 <span>{displayValue}</span>
//                 <svg
//                     className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                 >
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
//                 </svg>
//             </button>

//             {/* Dropdown time selector - Matching your image layout */}
//             {isOpen && (
//                 <div className="absolute top-full left-0 mt-2 bg-white border-2 border-orange-500 rounded-2xl shadow-lg z-10 p-4 w-80">
//                     <div className="flex gap-6 justify-between items-start">
//                         {/* Hours Column - Left */}
//                         <div className="text-center flex-1">
//                             <div className="font-semibold text-orange-500 mb-3 text-sm uppercase tracking-wide">Hour</div>
//                             <div className="max-h-64 overflow-y-auto">
//                                 <div className="flex flex-col justify-center items-center gap-2">
//                                     {hours.map(hour => (
//                                         <button
//                                             key={hour}
//                                             onClick={() => handleHourSelect(hour)}
//                                             className={`p-3 rounded-xl text-sm font-semibold transition-all ${hour === selectedHour
//                                                 ? 'bg-orange-500 text-white shadow-md'
//                                                 : 'hover:bg-orange-50 text-gray-700 border border-gray-200'
//                                                 }`}
//                                         >
//                                             {hour.toString().padStart(2, '0')}
//                                         </button>
//                                     ))}
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Minutes Column - Middle */}
//                         <div className="text-center flex-1">
//                             <div className="font-semibold text-orange-500 mb-3 text-sm uppercase tracking-wide">Minute</div>
//                             <div className="max-h-64 overflow-y-auto">
//                                 <div className="flex flex-col justify-center items-center gap-2 ">
//                                     {minutes.map(minute => (
//                                         <button
//                                             key={minute}
//                                             onClick={() => handleMinuteSelect(minute)}
//                                             className={`py-2 px-2 rounded-xl text-sm font-semibold transition-all ${minute === selectedMinute
//                                                 ? 'bg-orange-500 text-white shadow-md'
//                                                 : 'hover:bg-orange-50 text-gray-700 border border-gray-200'
//                                                 }`}
//                                         >
//                                             {minute.toString().padStart(2, '0')}
//                                         </button>
//                                     ))}
//                                 </div>
//                             </div>
//                         </div>

//                         {/* AM/PM Column - Right */}
//                         <div className="text-center flex-1">
//                             <div className="font-semibold text-orange-500 mb-3 text-sm uppercase tracking-wide">AM/PM</div>
//                             <div className="grid grid-cols-1 gap-2">
//                                 <button
//                                     onClick={() => handleAmPmSelect(true)}
//                                     className={`py-4 rounded-xl text-sm font-semibold transition-all ${isAm
//                                         ? 'bg-orange-500 text-white shadow-md'
//                                         : 'hover:bg-orange-50 text-gray-700 border border-gray-200'
//                                         }`}
//                                 >
//                                     AM
//                                 </button>
//                                 <button
//                                     onClick={() => handleAmPmSelect(false)}
//                                     className={`py-4 rounded-xl text-sm font-semibold transition-all ${!isAm
//                                         ? 'bg-orange-500 text-white shadow-md'
//                                         : 'hover:bg-orange-50 text-gray-700 border border-gray-200'
//                                         }`}
//                                 >
//                                     PM
//                                 </button>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Selected Time Display */}
//                     {/* <div className="mt-4 pt-4 border-t border-orange-200 text-center">
//                         <div className="text-orange-500 font-bold text-lg">
//                             {selectedHour.toString().padStart(2, '0')}:{selectedMinute.toString().padStart(2, '0')} {isAm ? 'AM' : 'PM'}
//                         </div>
//                         <div className="text-gray-500 text-sm mt-1">
//                             24h format: {formatTime(selectedHour, selectedMinute, isAm)}
//                         </div>
//                     </div> */}

//                     {/* Close Button */}
//                     <div className="mt-4 flex justify-center">
//                         <button
//                             onClick={() => setIsOpen(false)}
//                             className="px-6 py-2 bg-orange-500 text-white rounded-xl font-semibold hover:bg-orange-600 transition-colors"
//                         >
//                             Done
//                         </button>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default TimePicker;

import { useState, useEffect, useRef } from 'react';

const TimePicker = ({ value, onChange, className = "" }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedHour, setSelectedHour] = useState(9);
    const [selectedMinute, setSelectedMinute] = useState(0);
    const [isAm, setIsAm] = useState(true);
    const timePickerRef = useRef(null);

    // Convert 24h to 12h for display and selection
    const convert24to12 = (hour24) => {
        if (hour24 === 0 || hour24 === 12) return 12;
        return hour24 > 12 ? hour24 - 12 : hour24;
    };

    // Initialize from prop value (24-hour format)
    useEffect(() => {
        if (value) {
            const [hour24, minute] = value.split(':').map(Number);

            // Convert 24h to 12h for selection
            const hour12 = convert24to12(hour24);
            const amPm = hour24 < 12;

            setSelectedHour(hour12);
            setSelectedMinute(minute || 0);
            setIsAm(amPm);
        } else {
            // Default values for new time selection
            setSelectedHour(9);
            setSelectedMinute(0);
            setIsAm(true);
        }
    }, [value]);

    // Click outside to close
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (timePickerRef.current && !timePickerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('touchstart', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [isOpen]);

    const hours = Array.from({ length: 12 }, (_, i) => i + 1); // 1-12 for AM/PM
    const minutes = Array.from({ length: 12 }, (_, i) => i * 5); // 00, 05, 10, 15, ... 55

    const formatTime = (hour12, minute, isAm) => {
        // Convert 12-hour format to 24-hour format for API
        let twentyFourHour = hour12;

        if (isAm && hour12 === 12) {
            twentyFourHour = 0; // 12 AM = 00
        } else if (!isAm && hour12 !== 12) {
            twentyFourHour = hour12 + 12; // 1-11 PM = 13-23
        }
        // 12 PM remains 12

        return `${twentyFourHour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
    };

    const handleHourSelect = (hour12) => {
        setSelectedHour(hour12);
        const newTime = formatTime(hour12, selectedMinute, isAm);
        onChange(newTime);
    };

    const handleMinuteSelect = (minute) => {
        setSelectedMinute(minute);
        const newTime = formatTime(selectedHour, minute, isAm);
        onChange(newTime);
    };

    const handleAmPmSelect = (am) => {
        setIsAm(am);
        const newTime = formatTime(selectedHour, selectedMinute, am);
        onChange(newTime);
    };

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    // Display value in 12-hour format
    const displayValue = value
        ? `${convert24to12(parseInt(value.split(':')[0]))}:${parseInt(value.split(':')[1]).toString().padStart(2, '0')} ${parseInt(value.split(':')[0]) < 12 ? 'AM' : 'PM'}`
        : `${selectedHour}:${selectedMinute.toString().padStart(2, '0')} ${isAm ? 'AM' : 'PM'}`;

    return (
        <div ref={timePickerRef} className={`relative ${className}`}>
            {/* Custom-styled display */}
            <button
                type="button"
                onClick={handleToggle}
                className="
                    w-32 px-4 py-3 
                    rounded-2xl 
                    border-2 
                    border-gray-200 dark:border-white/10
                    bg-white dark:bg-[#111111]
                    text-black dark:text-white
                    font-semibold
                    hover:border-orange-600 dark:hover:border-orange-600
                    transition-colors
                    flex items-center justify-between
                    
                "
            >
                <span>{displayValue}</span>
                <svg
                    className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
            </button>

            {/* Dropdown time selector */}
            {isOpen && (
                <div className="absolute top-full left-0 mt-2 bg-white dark:bg-[#1a1a1a] border-2 border-orange-500 rounded-2xl shadow-lg z-50 p-4 w-80 max-w-[calc(100vw-5rem)]">
                    <div className="flex gap-2 sm:gap-6 justify-between items-start">
                        {/* Hours Column - Left */}
                        <div className="text-center flex-1">
                            <div className="font-semibold text-orange-500 mb-3 text-sm uppercase tracking-wide">Hour</div>
                            <div className="max-h-64 overflow-y-auto">
                                <div className="flex flex-col justify-center items-center gap-2">
                                    {hours.map(hour => (
                                        <button
                                            key={hour}
                                            onClick={() => handleHourSelect(hour)}
                                            className={`w-12 py-3 rounded-xl text-sm font-semibold transition-all ${hour === selectedHour
                                                ? 'bg-orange-500 text-white shadow-md'
                                                : 'hover:bg-orange-50 dark:hover:bg-white/5 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-white/10'
                                                }`}
                                        >
                                            {hour.toString().padStart(2, '0')}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Minutes Column - Middle */}
                        <div className="text-center flex-1">
                            <div className="font-semibold text-orange-500 mb-3 text-sm uppercase tracking-wide">Minute</div>
                            <div className="max-h-64 overflow-y-auto">
                                <div className="flex flex-col justify-center items-center gap-2">
                                    {minutes.map(minute => (
                                        <button
                                            key={minute}
                                            onClick={() => handleMinuteSelect(minute)}
                                            className={`w-12 py-2 rounded-xl text-sm font-semibold transition-all ${minute === selectedMinute
                                                ? 'bg-orange-500 text-white shadow-md'
                                                : 'hover:bg-orange-50 dark:hover:bg-white/5 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-white/10'
                                                }`}
                                        >
                                            {minute.toString().padStart(2, '0')}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* AM/PM Column - Right */}
                        <div className="text-center flex-1">
                            <div className="font-semibold text-orange-500 mb-3 text-sm uppercase tracking-wide">AM/PM</div>
                            <div className="grid grid-cols-1 gap-2">
                                <button
                                    onClick={() => handleAmPmSelect(true)}
                                    className={`py-4 rounded-xl text-sm font-semibold transition-all ${isAm
                                        ? 'bg-orange-500 text-white shadow-md'
                                        : 'hover:bg-orange-50 dark:hover:bg-white/5 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-white/10'
                                        }`}
                                >
                                    AM
                                </button>
                                <button
                                    onClick={() => handleAmPmSelect(false)}
                                    className={`py-4 rounded-xl text-sm font-semibold transition-all ${!isAm
                                        ? 'bg-orange-500 text-white shadow-md'
                                        : 'hover:bg-orange-50 dark:hover:bg-white/5 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-white/10'
                                        }`}
                                >
                                    PM
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Close Button */}
                    <div className="mt-4 flex justify-center">
                        <button
                            onClick={() => setIsOpen(false)}
                            className="px-6 py-2 bg-orange-500 text-white rounded-xl font-semibold hover:bg-orange-600 transition-colors"
                        >
                            Done
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TimePicker;
